import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'dark';
  subtext?: string;
  onClick?: () => void;
};
const variants = {
  primary: 'bg-sky-600 text-white shadow-lg shadow-sky-600/30 hover:bg-sky-700 focus:ring-sky-600/40 border-b-4 border-sky-800',
  dark: 'bg-slate-900 text-white shadow-lg shadow-slate-900/30 hover:bg-slate-800 focus:ring-slate-900/30 border-b-4 border-black'
};
export function Button({
  children,
  href,
  className = '',
  fullWidth,
  variant = 'primary',
  subtext,
  onClick
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} onClick={onClick} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex flex-col items-center justify-center rounded-xl px-7 py-4 text-center text-lg font-black uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus:ring-4 ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-376" data-mp="1jh0chk7z0o53">
      <span data-id="element-377" data-mp="oo3qfzyygwhu">{children}</span>
      {subtext && <span className="mt-1 text-xs font-semibold normal-case tracking-normal text-white/90" data-id="element-378" data-mp="om95ilnop4dr">
          {subtext}
        </span>}
    </motion.a>;
}